<template>
  <v-app>
    <router-view></router-view>
    <IdleComponent v-if="isRadiologist"/>
  </v-app>
</template>
<script>
import IdleComponent from "@/components/IdleComponent/IdleComponent.vue";
import {mapActions, mapState} from "vuex";
import UserTypes from "@/util/UserTypes";

export default {
  name: "App",
  data() {
    return {
      isIdle: false,
      idleTime: 0,
    };
  },
  components: { IdleComponent},
  computed: {
    ...mapState(["currentUser"]),
    isRadiologist() {
      return this.currentUser && this.currentUser.type === UserTypes.radiology;
    },
  },
  methods: {
    ...mapActions(["setMessage"])
  },
  mounted () {
    window.addEventListener("firebase-message", (e) => {
      const msg = e.detail;
      this.setMessage({
        message: msg.data.body,
        type: "info",
        timeout: 10000,
      });
    });
  },
  beforeUnmount() {
    window.removeEventListener("firebase-message");
  }
};
</script>
<style>
.messages-overlay {
  left: 50% !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translateX(-50%);
}
.v-alert.v-sheet.theme--dark.elevation-11.info {
  width: max-content;
}
</style>
